import * as React from "react"
const PayPal = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={30}
    height={29}
    fill="none"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M1.375 22.52 5.75 1.376h10.208c8.75 0 8.75 13.125 0 13.125h-6.27l-1.75 8.02H1.375Z"
    />
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M6.917 27.625 11.29 6.479H21.5c8.75 0 8.75 13.125 0 13.125h-6.271l-1.75 8.021H6.917Z"
    />
  </svg>
)
export default PayPal